module.exports = __webpack_public_path__ + "static/media/facilitate.f98ba11d.png";